import { X } from "lucide-react";

export function Modal({ open, onClose, title, children, size = "md" }) {
  if (!open) return null;
  const w = { sm: "max-w-md", md: "max-w-lg", lg: "max-w-2xl", xl: "max-w-4xl" }[size];
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center p-4 overflow-y-auto" data-testid="modal">
      <div className="fixed inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <div className={`relative card w-full ${w} my-8 animate-fadeup`}>
        <div className="flex items-center justify-between px-6 py-4 border-b border-white/5">
          <h3 className="font-heading font-semibold text-lg">{title}</h3>
          <button onClick={onClose} className="btn-ghost !px-2" data-testid="modal-close"><X size={18} /></button>
        </div>
        <div className="p-6">{children}</div>
      </div>
    </div>
  );
}

export function Field({ label, children }) {
  return <div><label className="label">{label}</label>{children}</div>;
}

export function ConfirmButton({ children, onConfirm, className = "btn-danger", testid }) {
  return (
    <button
      className={className}
      data-testid={testid}
      onClick={() => { if (window.confirm("Are you sure?")) onConfirm(); }}
    >
      {children}
    </button>
  );
}
